import React, { useEffect, useState, useRef } from 'react';
import Sidebar from '../components/Sidebar';
import "./dashboard.css";
import { Link, useSearchParams } from 'react-router-dom';
import Navbar from '../components/Navbar';
import { getallmembershiptypes } from '../store/slices/userSlice';
import PaginatedTable from '../services/paginatedtable';
import Swal from "sweetalert2";
import Membershippaymentsmodal from './membershippaymentsmodal';
import { getallmembershippayments } from '../store/slices/userSlice';
import { mediaURL } from '../services/api';
import { ProgressBar } from "react-bootstrap";
import * as XLSX from "xlsx";
import { uploadmembershippaymentsbulk } from '../services/dbService';

function Membershippayments() {
  const [searchParams] = useSearchParams();
  const [id, setId] = useState(null);
  const [total, setTotal] = useState();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);  // Initialize as empty array, not true
  const [error, setError] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false); // <-- Added this line

  const [selected, setSelected] = useState(null);

  const role = localStorage.getItem("role");
  const isAdmin = role === 'admin';
  const isUser = role === 'user';

  const [isOpen, setIsOpen] = useState(true);
  const fileInputRef = useRef(null);
  const [fileName, setFileName] = useState("");
  const [validRows, setValidRows] = useState([]);
  const [invalidRows, setInvalidRows] = useState([]);
  const [uploading, setUploading] = useState(false);
  const templateFile = "paymentupdloadformat.xlsx";

  const fetchData = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await getallmembershippayments();
      if (response.status == '200') {
        if (localStorage.getItem('role') === 'admin') {
          setData(Array.isArray(response?.data) ? response.data : []);
        } else {
          setData(
            Array.isArray(response?.data)
              ? response.data.filter(x => x.member === localStorage.getItem('id'))
              : []
          );
        }

      }
      else {
        setData([]);
      }


    } catch (err) {
      Swal.fire('Error', 'Error getting data.', 'error');
      setError('Error getting data.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    try{
      fetchData();
    }
    catch (error) {
      console.error("Error in fetching data.", error);
      Swal.fire("Error", "Error in fetching data.", "error");
    }
  
  }, []);

  const handleEdit = (item) => {
    try{
      setSelected(item);
      setIsModalOpen(true);
    }
    catch (error) {
      console.error("Error in editing data.", error);
      Swal.fire("Error", "Error in editing data.", "error");
    }
  
  };

  const bankOptions = [
    "Bank of America",
    "Chase Bank",
    "Wells Fargo",
    "Citibank",
    "U.S. Bank",
    "PNC Bank",
    "Capital One",
    "TD Bank",
    "BB&T (now Truist)",
    "Regions Bank",
    "Others"
  ];

  const paymentmodeOptions = [
    "Cash",
    "Cheque",
    "Bank Transfer",
    "Paypal",
    "Others"
  ];

  const validateRow = (row, index) => {
    const errors = [];
  
    try {
      // Validate date format: YYYY-MM-DD
      if (row.date && !/^\d{4}-\d{2}-\d{2}$/.test(row.date)) {
        errors.push("Invalid date format. Use YYYY-MM-DD");
      }
  
      // Validate email format
      if (row.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(row.email)) {
        errors.push("Invalid email format");
      }
  
      // Name must be provided
      if (!row.name || row.name.trim() === "") {
        errors.push("Name is required");
      }
  
      // Validate payment mode
      if (row.paymentmode && !paymentmodeOptions.includes(row.paymentmode)) {
        errors.push(`Invalid Payment Mode. Allowed: ${paymentmodeOptions.join(", ")}`);
      }
  
      // Validate bank
      if (row.bank && !bankOptions.includes(row.bank)) {
        errors.push(`Invalid Bank. Allowed: ${bankOptions.join(", ")}`);
      }
  
      // Transaction ID required for certain payment modes
      if (["Paypal", "Bank Transfer"].includes(row.paymentmode)) {
        if (!row.transactionid || row.transactionid.trim() === "") {
          errors.push(`Transaction ID is required for ${row.paymentmode}`);
        }
      }
  
      // Cheque-specific validations
      if (row.paymentmode === "Cheque") {
        if (!row.chequenumber || row.chequenumber.trim() === "") {
          errors.push("Cheque number is required for Cheque payment");
        }
        if (!row.chequedate || row.chequedate.trim() === "") {
          errors.push("Cheque date is required for Cheque payment");
        }
        if (!row.bank || row.bank.trim() === "") {
          errors.push("Bank is required for Cheque payment");
        }
  
        const amt = parseFloat(row.amount);
        if (row.amount && (!Number.isFinite(amt) || amt % 20 !== 0)) {
          errors.push("Payment amount must be a valid number and a multiple of 20");
        }
      }
    } catch (err) {
      console.error(`Error validating row at index ${index}:`, err);
      errors.push("Unexpected error during validation");
    }
  
    return {
      ...row,
      __rowIndex: index + 2,
      __errors: errors,
    };
  };
  


  const handleFileUpload = (event) => {
    try {
      const file = event.target.files[0];
      if (!file) return;
  
      const extension = file.name.split(".").pop().toLowerCase();
      if (!["xls", "xlsx"].includes(extension)) {
        Swal.fire("Invalid File", "Please upload an Excel (.xls or .xlsx) file", "warning");
        return;
      }
  
      setFileName(file.name);
      const reader = new FileReader();
  
      reader.onload = (e) => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: "array" });
          const sheet = workbook.Sheets[workbook.SheetNames[0]];
          const jsonData = XLSX.utils.sheet_to_json(sheet);
  
          const parseExcelDate = (excelDate) => {
            if (!excelDate) return "";
            if (typeof excelDate === "number") {
              const jsDate = new Date((excelDate - 25569) * 86400 * 1000);
              return jsDate.toISOString().split("T")[0];
            } else if (typeof excelDate === "string") {
              const parsed = new Date(excelDate);
              return isNaN(parsed) ? "" : parsed.toISOString().split("T")[0];
            }
            return "";
          };
  
          const formattedData = jsonData.map((row) => ({
            date: parseExcelDate(row.date) || "",
            email: row.email || "",
            name: row.name || "",
            amount: row.amount || "",
            paymentmode: row.paymentmode || "",
            transactionid: row.transactionid || "",
            chequenumber: row.chequenumber || "",
            chequedate: parseExcelDate(row.chequedate) || "",
            bank: row.bank || "",
          }));
  
          const validated = formattedData.map(validateRow);
          setValidRows(validated.filter((r) => r.__errors.length === 0));
          setInvalidRows(validated.filter((r) => r.__errors.length > 0));
        } catch (innerErr) {
          console.error("Error processing Excel data:", innerErr);
          Swal.fire("Error", "Failed to process the uploaded file.", "error");
        }
      };
  
      reader.readAsArrayBuffer(file);
    } catch (err) {
      console.error("Error in handleFileUpload:", err);
      Swal.fire("Error", "File upload failed.", "error");
    }
  };
  

  const handleUpload = async () => {
    try {
      const allRowsRaw = [...validRows, ...invalidRows.filter((r) => r.__errors.length === 0)];
      const allRows = allRowsRaw.map(({ __errors, __rowIndex, ...rest }) => rest);
  
      if (!allRows.length) {
        Swal.fire("No valid data to upload");
        return;
      }
  
      setUploading(true);
  
      const response = await uploadmembershippaymentsbulk(allRows);
  
      if (response.status === 200) {
        Swal.fire("Success", "Data uploaded successfully", "success");
        resetUpload();
      } else {
        Swal.fire("Error", "Error uploading Data", "error");
        resetUpload();
      }
    } catch (err) {
      console.error("Upload failed:", err);
      Swal.fire("Error", err.response?.data?.error || "Upload failed", "error");
    } finally {
      setUploading(false);
    }
  };
  

  const handleFieldChange = (index, field, value) => {
    try {
      const updated = [...invalidRows];
      updated[index][field] = value;
  
      const validationErrors = validateRow(updated[index], index).__errors;
      const fieldLabel = field.replace(/_/g, ' ').replace(/([a-z])([A-Z])/g, '$1 $2')
                              .split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
  
      updated[index].__errors = validationErrors.filter(
        (error) => !error.startsWith(`Invalid ${fieldLabel}.`)
      );
  
      updated[index].__errors.push(
        ...validationErrors.filter((error) => error.startsWith(`Invalid ${fieldLabel}.`))
      );
  
      setInvalidRows(updated);
    } catch (err) {
      console.error("Error in handleFieldChange:", err);
      Swal.fire("Error", "Failed to update the field.", "error");
    }
  };
  

  const resetUpload = () => {
    setFileName("");
    setValidRows([]);
    setInvalidRows([]);
  };


  return (
    <div>
      <Navbar />
      <Sidebar />
      {loading && (
        <div className="preloader">
          <div className="lds-ripple">
            <div className="lds-pos"></div>
            <div className="lds-pos"></div>
          </div>
        </div>
      )}

      <div id="main-wrapper">
        <div className="page-wrapper d-block">
          <div className="body-wrapper">
            <div className="container-fluid">
              <div className="folio-container"></div>
              <div className="row">
                <div className="col-lg-12 d-flex align-items-stretch">
                  <div className="card w-100">
                    <div className="card-header" style={{ background: "#f06969" }}>
                      <div className="d-sm-flex d-block align-items-center justify-content-between mb-4">
                        <h4 className="card-title fw-semibold">Membership Payments</h4>

                      </div>
                    </div>
                    <div className="card-body">
                      <div className="d-flex flex-wrap align-items-center gap-2 mb-4">
                        {isAdmin && (
                          <>
                            <button
                              className="btn btn-primary btn-sm"
                              style={{ minWidth: 180 }}
                              onClick={() => setIsModalOpen(true)}
                            >
                              New
                            </button>

                            <button
                              className="btn btn-info btn-sm"
                              style={{ minWidth: 180 }}
                              onClick={() => window.open(`${mediaURL}/${templateFile}`, "_blank")}
                            >
                              Download Format
                            </button>

                            <div>
                              <input
                                type="file"
                                className="d-none"
                                accept=".xlsx, .xls"
                                onChange={handleFileUpload}
                                ref={fileInputRef}
                              />
                              <button
                                className="btn btn-success btn-sm"
                                style={{ minWidth: 180 }}
                                onClick={() => fileInputRef.current.click()}
                              >
                                Upload Data
                              </button>
                            </div>
                          </>
                        )}
                      </div>


                      <div className="col-lg-12">
                        {loading ? (
                          <p>Loading...</p>
                        ) : error ? (
                          <p className="text-danger">Error: {error}</p>
                        ) : data.length > 0 ? (
                          <div className="table-responsive">


                            {(isAdmin || isUser) && (
                              <PaginatedTable
                                columns={[
                                  "date",
                                  "member_name",
                                  "email",
                                  "membership_type",
                                  "amount",
                                  "paymentmode",
                                  "transactionid",
                                  "chequenumber",
                                  "bank",
                                  "chequedate",
                                  "orderid",
                                ]}
                                data={data}
                                {...(isAdmin && { onEdit: handleEdit })}

                              />
                            )}

                          </div>
                        ) : (
                          <p>No data available</p>
                        )}
                      </div>

                      <div className="row mt-3">
                        <div className="col-lg-12">
                          {fileName && <p className="text-muted">Uploaded File: {fileName}</p>}
                          {uploading && <ProgressBar animated now={100} label="Uploading..." className="w-100 my-2" />}
                          {validRows.length > 0 && <p className="text-success">✅ {validRows.length} rows validated</p>}


                          {invalidRows.length > 0 && (
                            <div className="w-100 mt-3">
                              <p className="text-danger">❌ {invalidRows.length} rows have errors:</p>
                              <div className="table-responsive">
                                <table className="table table-bordered table-hover">
                                  <thead>
                                    <tr>
                                      <th>Name</th>
                                      <th>Email</th>
                                      <th>Date</th>
                                      <th>Amount</th>
                                      <th>Payment Mode</th>
                                      <th>Transaction ID</th>
                                      <th>Cheque Number</th>
                                      <th>Cheque Date</th>
                                      <th>Bank</th>

                                      <th>Errors</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {invalidRows.map((row, i) => (
                                      <tr key={i}>
                                        <td>
                                          <input
                                            type="text"
                                            value={row.name}
                                            onChange={(e) => handleFieldChange(i, "name", e.target.value)}
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="email"
                                            value={row.email}
                                            onChange={(e) => handleFieldChange(i, "email", e.target.value)}
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="text"
                                            value={row.date}
                                            placeholder="DD-MM-YYYY"
                                            onChange={(e) => handleFieldChange(i, "date", e.target.value)}
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="number"
                                            value={row.amount}
                                            onChange={(e) => handleFieldChange(i, "amount", e.target.value)}
                                          />
                                        </td>
                                        <td>
                                          <select
                                            value={row.paymentmode}
                                            onChange={(e) => handleFieldChange(i, "paymentmode", e.target.value)}
                                          >
                                            <option value="">Select</option>
                                            {paymentmodeOptions.map((option) => (
                                              <option key={option} value={option}>{option}</option>
                                            ))}
                                          </select>
                                        </td>
                                        <td>
                                          <input
                                            type="text"
                                            value={row.transactionid}
                                            onChange={(e) => handleFieldChange(i, "transactionid", e.target.value)}
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="text"
                                            value={row.chequenumber}
                                            onChange={(e) => handleFieldChange(i, "chequenumber", e.target.value)}
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="text"
                                            value={row.chequedate}
                                            placeholder="DD-MM-YYYY"
                                            onChange={(e) => handleFieldChange(i, "chequedate", e.target.value)}
                                          />
                                        </td>
                                        <td>
                                          <select
                                            value={row.bank}
                                            onChange={(e) => handleFieldChange(i, "bank", e.target.value)}
                                          >
                                            <option value="">Select</option>
                                            {bankOptions.map((option) => (
                                              <option key={option} value={option}>{option}</option>
                                            ))}
                                          </select>
                                        </td>

                                        <td className="text-danger">{row.__errors.join(", ")}</td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          )}

                          {(validRows.length > 0 || invalidRows.some((r) => r.__errors.length === 0)) && (
                            <button className="btn btn-primary  btn-sm me-2" style={{ marginTop: "20px" }}
                              onClick={handleUpload} disabled={uploading || invalidRows.some(r => r.__errors.length > 0)}>
                              Final Upload
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <Membershippaymentsmodal
                    isModalOpen={isModalOpen}
                    setIsModalOpen={setIsModalOpen}
                    reloadData={fetchData}
                    selected={selected}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Membershippayments;
